import { MonitorObjectType } from "@/declare/enums/monitor-object-type";
import { useCallback, useState } from "react";

export interface SystemStatus {
    activeMonitorObjectId?: number; // 当前选中的监测对象id
    setActiveMonitorObjectId?: React.Dispatch<React.SetStateAction<number>> // 设置当前选中的监测对象id的方法
    monitorObjectTypeList?: number[]; // 激活的监测对象
    setMonitorObjectTypeList?: React.Dispatch<React.SetStateAction<number[]>>; // 设置激活的监测对象的方法
    toggleMonitorObjectType?: (type: number) => void; // 切换激活的监测对象的方法
    showMObjectLabelDetailList?: number[];  // 监测对象详情弹窗id列表
    setShowMObjectLabelDetailList?: (ids: number[]) => void;   // 设置监测对象详情弹窗id列表
    openMObjectLabelDetail?: (id: number) => void;   // 打开监测对象详情弹窗显示
    closeMObjectLabelDetail?: (id: number) => void;   // 关闭监测对象详情弹窗显示
    activeGroupUuids?: string[];   // 当前激活的group的uuids
    setActiveGroupUuids?: (uuids: string[]) => void;   // 设置当前激活的group的uuids
}

export function useSystemService() {
    const [monitorObjectTypeList, setMonitorObjectTypeList] = useState<number[]>([MonitorObjectType.COMPONENT, MonitorObjectType.STRUCTURE, MonitorObjectType.ENVIRONMENT, MonitorObjectType.DEVICE]); // 激活的监测对象
    const [activeMonitorObjectId, setActiveMonitorObjectId] = useState<number>(null); // 当前选中的监测对象id

    const [showMObjectLabelDetailList, setShowMObjectLabelDetailList] = useState<number[]>([])
    const [activeGroupUuids, setActiveGroupUuids] = useState<string[]>([]) // 当前激活的group的uuids

    /**
     * 切换激活的监测对象的方法
     */
    const toggleMonitorObjectType = useCallback((type: number) => {
        let idx = monitorObjectTypeList?.findIndex(item => item === type);
        if (idx === -1) {
            monitorObjectTypeList.push(type);
            setMonitorObjectTypeList([...monitorObjectTypeList]);
        } else {
            monitorObjectTypeList.splice(idx, 1);
            setMonitorObjectTypeList([...monitorObjectTypeList]);
        }
    }, [monitorObjectTypeList]);

    /**
     * 打开监测对象详情弹窗显示
     * @param id 
     */
    const openMObjectLabelDetail = (id: number) => {
        if (!showMObjectLabelDetailList.includes(id)) {
            setShowMObjectLabelDetailList([
                ...showMObjectLabelDetailList,
                id
            ])
        }
    }

    /**
     * 关闭监测对象详情弹窗显示
     * @param id 
     */
    const closeMObjectLabelDetail = (id: number) => {
        setShowMObjectLabelDetailList([...showMObjectLabelDetailList.filter(i => i != id)])
    }



    return {
        activeMonitorObjectId, setActiveMonitorObjectId,
        monitorObjectTypeList,
        setMonitorObjectTypeList,
        toggleMonitorObjectType,
        showMObjectLabelDetailList,
        setShowMObjectLabelDetailList,
        openMObjectLabelDetail,
        closeMObjectLabelDetail,
        activeGroupUuids,
        setActiveGroupUuids,
    } as SystemStatus;
}
